// extracted by mini-css-extract-plugin
export default {"root":"Table-root-ff578e3ccfdf427fdc75ef9b0b1ab942","fullWidth":"Table-fullWidth-53e62978a7274502b18672b4c7754d0e"};